import { Dispatch, FC, SetStateAction } from 'react';
import { GroupsItem } from './GroupsItem';
import { typePreachingGroup, typeUser } from '@monorepo/models';
import { useGetIsDarkMode } from 'src/custom-hooks';

type propsType = {
    groups: typePreachingGroup[];
    numberConfirmed: boolean;
    readOnly?: boolean;
    setGroups: Dispatch<SetStateAction<typePreachingGroup[] | null>>;
    users: typeUser[];
};

export const Groups: FC<propsType> = ({ groups, numberConfirmed, readOnly, setGroups, users }) => {
    const isDarkMode = useGetIsDarkMode();

    return (
        <>
        <div className={`${!numberConfirmed ? 'row' : ''} mt-4`}>
            {groups.map(g =>
                <GroupsItem key={g.numberOfGroup}
                    group={g}
                    groups={groups}
                    numberConfirmed={numberConfirmed}
                    readOnly={readOnly}
                    setGroups={setGroups}
                    users={users}
                />
            )}
        </div>
        <div className={'card mb-4'}>
            <div className={`card-header ${isDarkMode ? 'bg-dark text-white border' : ''} fw-bolder`}>
                <h4 className={'pt-1'}>
                    TOTALES
                </h4>
            </div>
            <div className={`card-body ${isDarkMode ? 'bg-lightdark text-white border' : ''} fw-bolder`}>
                {groups.map(g =>
                    <div key={g.numberOfGroup}>
                        <span className={`fw-bold pe-2 ${g.users.length < 10 ? 'me-2' : 'me-0'}`}>Grupo {g.numberOfGroup}:</span> {g.users.length} hermanos
                    </div>
                )}
            </div>
            <div className={`card-footer ${isDarkMode ? 'bg-dark text-white border' : ''} fw-bolder`}>
                Cantidad de hermanos: {groups.reduce((ac, t) => t.users.length + ac, 0)}
            </div>
        </div>
        </>
    );
}
